export default "__VITE_ASSET__5Phz0ObA__"